// 所有彩种ID
export const Lottery = {
  fc3d: { id: 301, name: '福彩3D' }, pl3: { id: 302, name: '排列3' },
  pl5: { id: 303, name: '排列5' }, ssq: { id: 1026, name: '双色球' },
  dlt: { id: 1025, name: '超级大乐透' }, qxc: { id: 2013, name: '七星彩' },
  kl8: { id: 2015, name: '快乐8' }, qlc: { id: 5016, name: '七乐彩' }
}

export const LotteryInfos = [
  {
    "id": Lottery.kl8.id, "name": Lottery.kl8.name, "type": 8, "cycle": 351, 'ftc': 0,
    "icon_url": "11_ssc_xhnffc.webp", "img_url": "ssc_11_xheff_icon.png",
    "gw": "", 'dEndTime': '21:00',
    'ball': [
      { 'r': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80'], 'n': 20, 'z': 1 }
    ],
  },
  {
    "id": Lottery.fc3d.id, "name": Lottery.fc3d.name, "type": 2, "cycle": 351, 'ftc': 0,
    "icon_url": "08_ssc_360ffc.webp", "img_url": "ssc_08_360ffc.webp",
    "gw": "http://www.cwl.gov.cn/html5/ygkj/wqkjgg/fc3d/", 'dEndTime': '20:30',
    'ball': [
      { 'r': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], 'n': 3, 'z': 3 }
    ]
  },
  {
    "id": Lottery.ssq.id, "name": Lottery.ssq.name, "type": 7, "cycle": 153, 'ftc': 0,
    "icon_url": "202105_ffc_ggffc.webp", "img_url": "202105_ggffc_ffc.webp",
    "gw": "", 'dEndTime': '20:00',
    'ball': [
      { 'r': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33'], 'n': 6, 'z': 1 },
      { 'r': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'], 'n': 1, 'z': 1 }
    ]
  },
  {
    "id": Lottery.dlt.id, "name": Lottery.dlt.name, "type": 6, "cycle": 150, 'ftc': 1,
    "icon_url": "14_ssc_mgsjffc.webp", "img_url": "ssc_14_mgsjffc_icon.webp",
    "gw": "", 'dEndTime': '21:00',
    'ball': [
      { 'r': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35'], 'n': 5, 'z': 1 },
      { 'r': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'], 'n': 2, 'z': 1 }
    ]
  },
  {
    "id": Lottery.pl3.id, "name": Lottery.pl3.name, "type": 3, "cycle": 351, 'ftc': 1,
    "icon_url": "09_ssc_xqqtxffc.webp", "img_url": "ssc_09_xqqtxffc.webp",
    "gw": "https://www.zjlottery.com/win/SResult.asp?flag=C", 'dEndTime': '21:00',
    'ball': [
      { 'r': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], 'n': 3, 'z': 3 }
    ]
  },
  {
    "id": Lottery.pl5.id, "name": Lottery.pl5.name, "type": 4, "cycle": 351, 'ftc': 1,
    "icon_url": "10_ssc_lhnffc.webp", "img_url": "ssc_10_lheffc.png",
    "gw": "https://www.zjlottery.com/win/SResult.asp?flag=E", 'dEndTime': '21:00',
    'ball': [
      { 'r': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], 'n': 5, 'z': 5 }
    ]
  },
  {
    "id": Lottery.qxc.id, "name": Lottery.qxc.name, "type": 5, "cycle": 1, 'ftc': 1,
    "icon_url": "11_ssc_xhnffc.webp", "img_url": "ssc_11_xheff_icon.png",
    "gw": "", 'dEndTime': '21:00',
    'ball': [
      { 'r': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], 'n': 6, 'z': 6 },
      { 'r': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'], 'n': 1, 'z': 1 }
    ]
  },
]